<div class="rounded-2xl bg-white p-[16px] shadow-[0px_0px_8px_0px_rgba(0,0,0,0.12)]">
  <app-supplier-filters-component (applyFilters)="applyFilters($event)" (resetFilters)="resetFilters()" />

  <app-supplier-table-component
    [suppliers]="suppliers()"
    [state]="state()"
    [currentPage]="currentPage()"
    [itemsPerPage]="itemsPerPage()"
    [isFiltersApplied]="isFiltersApplied()"
    (retry)="loadSuppliers()"
    (viewSupplier)="onViewSupplier($event)"
    (editSupplier)="onEditSupplier($event)"
    (deleteSupplier)="openDeleteDialog($event)"
    (activateSupplier)="openToggleDialog($event, true)"
    (deactivateSupplier)="openToggleDialog($event, false)" />
</div>

@if (state() === "success") {
  <app-pagination
    [itemsPerPage]="itemsPerPage()"
    [currentPage]="currentPage()"
    [getPageNumbers]="pageNumbers()"
    [totalPages]="totalPages()"
    [startItem]="startItem()"
    [endItem]="endItem()"
    [totalItems]="totalItems()"
    (previousPage)="onPageChange(currentPage() - 1)"
    (nextPage)="onPageChange(currentPage() + 1)"
    (goToPage)="onPageChange($event)"
    (changePageNumber)="onPageSizeChange(+$event)" />
}

@if (supplierToToggle()) {
  <app-confirmation-dialog
    layout="start"
    [title]="toggleTitle()"
    [description]="toggleDescription()"
    [confirmContent]="toggleConfirm()"
    [cancelContent]="deleteCancel"
    [isLoading]="toggling()"
    [error]="toggleError()"
    (onSubmit)="confirmToggle()"
    (onCancel)="closeToggleDialog()" />
}

@if (supplierToDelete()) {
  <app-confirmation-dialog
    layout="start"
    [title]="deleteTitle"
    [description]="deleteDescription()"
    [confirmContent]="deleteConfirm"
    [cancelContent]="deleteCancel"
    [isLoading]="deleting()"
    [error]="deleteError()"
    (onSubmit)="confirmDelete()"
    (onCancel)="closeDeleteDialog()" />
}

@if (showSuccessMessage()) {
  <app-successful-notification type="success" [title]="deleteSuccess" />
}
